import { useState } from 'react';
import { Car, Fuel } from 'lucide-react';
import Page from '@/components/Page';
import { Tabs, TabPanel } from '@/components/ui';
import DashboardEnginSection from '@/components/dashboard/DashboardEnginSection';
import CiterneEcartSection from '@/components/dashboard/CiterneEcartSection';

export default function HomePage() {
  const [tab, setTab] = useState(0);

  return (
    <Page title="Dashboard">
      <Tabs
        tabs={[
          { label: 'Engin', icon: <Car className="h-4 w-4" /> },
          { label: 'Citerne', icon: <Fuel className="h-4 w-4" /> },
        ]}
        value={tab}
        onChange={setTab}
      />

      <TabPanel value={tab} index={0}>
        <DashboardEnginSection />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <CiterneEcartSection />
      </TabPanel>
    </Page>
  );
}
